import { motion } from "framer-motion";
import { Check } from "lucide-react";

const ForWhom = () => {
  const items = [
    "Sentem dificuldade para emagrecer",
    "Já fizeram diversas dietas sem sucesso duradouro",
    "Sofrem com efeito sanfona",
    "Desejam melhorar composição corporal",
    "Querem ganhar massa muscular",
    "Possuem lipedema",
    "Possuem SOP",
    "Desejam envelhecer com mais saúde e qualidade de vida",
    "Buscam acompanhamento médico próximo e individualizado",
  ];

  return (
    <section
      id="para-quem"
      className="relative overflow-hidden bg-[#3E2723] py-20 md:py-28"
      data-testid="for-whom-section"
    >
      <div className="pointer-events-none absolute top-10 right-10 h-72 w-72 rounded-full bg-[#D4AF37]/10 blur-3xl" />

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 md:px-12 lg:grid-cols-12 lg:items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-5"
        >
          <p className="mb-3 text-xs uppercase tracking-[0.3em] text-[#D4AF37]">
            Para você
          </p>
          <h2 className="font-serif text-3xl leading-tight text-[#FDFBF7] sm:text-4xl lg:text-5xl">
            Para quem é o <br />
            <em className="italic text-[#D4AF37]">acompanhamento</em>
          </h2>
          <p className="mt-6 max-w-md text-base text-[#FDFBF7]/70">
            Mulheres que desejam transformar a saúde com estratégia,
            constância e ciência. Se você se identifica com algum dos pontos
            ao lado, seu lugar é aqui.
          </p>
        </motion.div>

        <div className="lg:col-span-7">
          <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {items.map((item, i) => (
              <motion.li
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.5,
                  delay: i * 0.05,
                  ease: [0.16, 1, 0.3, 1],
                }}
                className="flex items-start gap-3 rounded-2xl border border-white/10 bg-white/5 px-5 py-4 backdrop-blur-sm transition-all hover:border-[#D4AF37]/40 hover:bg-white/10"
                data-testid={`for-whom-item-${i}`}
              >
                <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-[#D4AF37]">
                  <Check className="h-3 w-3 text-[#3E2723]" strokeWidth={3} />
                </span>
                <span className="text-sm text-[#FDFBF7]/95 md:text-base">
                  {item}
                </span>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ForWhom;
